import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../../app.service';
import { GenericIdName } from '../../../../shared/models/common-search-filters.model';
import { InspectionEventSearchFiltersVM, InspectionEventSearchResultVM, JobsiteSelectionFilter, ModelSelectionFilter, PerformSearchDigitalForm } from '../../../GET_NEW_UI/favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../../../GET_NEW_UI/favourite-dialog/favourite-dialog.service';
import { EquipmentSelectItem } from '../../../GET_NEW_UI/setup-equipment/setup-equipment.model';
import { GETSetupEquipmentService } from '../../../GET_NEW_UI/setup-equipment/setup-equipment.service';
import { CustomerSelectItem } from '../../../setup-equipment/setup-equipment.model';

@Component({
  selector: 'app-inspection-events',
  templateUrl: './inspection-events.component.html',
  styleUrls: ['./inspection-events.component.scss']
})
export class inspectioneventsComponent implements OnInit {

  // Drop-down lists
  customerList: CustomerSelectItem[] = [];
  jobsiteList: GenericIdName[] = [];
  equipmentList: EquipmentSelectItem[] = [];
  familyList: GenericIdName[] = [];
  modelList: GenericIdName[] = [];

  // Search Filters
  selectedCustomer: number[] = [];
  selectedJobsite: number[] = [];
  selectedEquipment: number[] = [];
  selectedFamily: number[] = [];
  selectedModel: number[] = [];
  //search result
  PerformResult: InspectionEventSearchResultVM[];
  loading: boolean = false;
  noRecords: boolean = false;

  //appUris: AppUris;

  constructor(
    private _appService: AppService, private _equipmentService: GETSetupEquipmentService,
    public _favouriteDialogService: FavouriteDialogService
  ) { }

  ngOnInit() {
    this._appService.setPageTitle('Inspection Events Detail');
    this.loadCustomers();
    if (this.selectedCustomer.length > 0)
      this.loadJobsitesForCustomer();
    this._favouriteDialogService.getFamilyList();
    //this._appService.getAppUris().subscribe(result => { this.appUris = result; });
  }

  loadCustomers() {
    this._equipmentService.getCustomerList().subscribe(r => {
      this.customerList = r;
      if (this.customerList.length == 1) {
        let onlyonecus = this.customerList[0].Id;
        let arrycus = [];
        arrycus.push(onlyonecus);
        this.selectedCustomer = arrycus;
        if (this.selectedCustomer.length > 0) {
          this.loadJobsitesForCustomer();
        }
      }
    });
  }
  // Show the list of Jobsites for the selected customer.
  // Also loads the observation lists.
  loadJobsitesForCustomer() {
    if (this.selectedCustomer == null)
      return;
    this.selectedJobsite = null;
    this.jobsiteList = null;
    this.selectedEquipment = null;
    this.equipmentList = [];
    var params: JobsiteSelectionFilter = {
      Customers: this.selectedCustomer,
    }
    this._favouriteDialogService.GetjobsitesAvailable(params).subscribe(r => {
      if (r) {
        this.jobsiteList = r;
        //console.log("Length jobsite",this.jobsiteList.length)
        if (this.jobsiteList.length == 1) {
          let onlyonejob = this.jobsiteList[0].Id;
          let arry = [];
          arry.push(onlyonejob);
          this.selectedJobsite = arry;
          this.loadEquipmentForJobsite();
        }
      }
    });
  }

  // Show the list of equipment for the selected jobsite.
  loadEquipmentForJobsite() {
    if (this.selectedJobsite == null)
      return;
    var params: number[] = this.selectedJobsite;
    this._favouriteDialogService.GetEquipmentAvailable(params).subscribe(r => {
      if (r) {
        this.equipmentList = r;
      }
    });
  }

  loadModelList() {
    this.modelList = null
    var params: ModelSelectionFilter = {
      Families: this.selectedFamily,
      Makes: []
    }
    this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
      if (r) {
        this.modelList = r;
      }
    });

  }

  ResetFields() {
    this.selectedCustomer = [];
    this.selectedJobsite = [];
    this.selectedEquipment = [];
    this.selectedFamily = [];
    this.selectedModel = [];
    this.noRecords = false;
  }

  submitSelection() {
    this.noRecords = false;
    this.loading = true;
    var params: InspectionEventSearchFiltersVM = {
      customers: this.selectedCustomer,
      jobsites: this.selectedJobsite,
      equipments: this.selectedEquipment,
      families: this.selectedFamily,
      models: this.selectedModel,
    }

    this._favouriteDialogService.GetInspectionEventsSearchResult(params).subscribe(res => {
      this.PerformResult = res;
      if (this.PerformResult.length > 0)
        this.noRecords = false;
      else
        this.noRecords = true;
      this.loading = false;
    })
  }
  rowClick(customerId : number, InspectionId: number) {
    //window.open(this.appUris.UCUri + 'Api/Inspection/Inspections?Customer=&InspectionId=' + InspectionId.toString(), '_blank');
    window.open(this._appService.getBaseURL() + 'Api/Inspection/Inspections?Customer=' + customerId.toString() + '&InspectionId=' + InspectionId.toString(), '_blank');
  }
  getJSON() {
    //window.open(this.appUris.UCUri + 'Api/Inspection/Inspections?Customer=' + this.selectedCustomer + '&InspectionId=0', '_blank');
    window.open(this._appService.getBaseURL() + 'Api/Inspection/Inspections?Customer=' + this.selectedCustomer + '&InspectionId=0', '_blank');
  }
  getCSV() {
    this.loading = true;
    this.downloadFile(this.PerformResult)
    this.loading = false;
  }
  printPDF(printPdf: string) {
    window.open(printPdf, '_blank');
  }

 downloadFile(data: any[]) {
  const columnOrder = [
    "customer", "jobsite", "model", "inspectionDate", "riskRating",
    "inspectionComments", "unitNumber", "recommendedActions", "inspectionId", "inspectionType",
    "smu", "printPdf", "measuredDataPer", "bushTurnLeft", "bushTurnRight", "actions"
  ];

  const _data: any[] = [];
  const dynamicHeadersSet: Set<string> = new Set(); // for measured part headers
  let customerName: string = "";

  const toolKeywords = [
    "Invalid Tool", "Ruler", "Depth Gauge", "UT", "Calipers",
    "Keeper Orientation", "Drive Lugs Engaged", "YES or NO",
    "Observation", "Eval", "Pass or Fail"
  ];
  const toolRegex = new RegExp(`\\b(${toolKeywords.join("|")})\\b`, "i");

  data.forEach(p => {
    const _o: any = {};

    for (const key of columnOrder) {
      if (key === "customer") {
        _o["Customer"] = p[key];
        customerName = _o["Customer"] || "Export";
      } else if (key === "jobsite") {
        _o["Job Site"] = p[key];
      } else if (key === "model") {
        _o["Model"] = p[key];
      } else if (key === "inspectionDate") {
        _o["Inspection Date"] = p[key];
      } else if (key === "riskRating") {
        _o["Risk Rating"] = p[key];
      } else if (key === "inspectionComments") {
        _o["Inspection Comments"] = p[key];
      } else if (key === "unitNumber") {
        _o["Unit #"] = p[key];
      } else if (key === "recommendedActions") {
        _o["Recommended Actions"] = p[key] ? p[key].split('|').join(' | ') : "";
      } else if (key === "inspectionId") {
        _o["Your Inspection ID"] = p[key];
      } else if (key === "inspectionType") {
        _o["Inspection Type"] = p[key];
      }else if (key === "smu") {
        _o["Meter Read / SMU"] = p[key];
      } else if (key === "printPdf") {
        _o["Pdf url"] = p[key];
      } else if (key === "measuredDataPer") {
        const parts = p[key] ? p[key].split('|') : [];

        parts.forEach(part => {
          const match = part.match(toolRegex);
          if (match) {
            const toolIndex = part.indexOf(match[0]);
            const partName = part.substring(0, toolIndex).trim(); // e.g., "Link 1 L"
            const header = `Measured Data Part Wear % per Component ${partName}`;
            _o[header] = part.trim();
            dynamicHeadersSet.add(header);
          } else {
            const fallbackHeader = `Measured Data Part Wear % per Component Unknown ${dynamicHeadersSet.size + 1}`;
            _o[fallbackHeader] = part.trim();
            dynamicHeadersSet.add(fallbackHeader);
          }
        });
      } else if (key === "bushTurnLeft") {
        _o["Bush Turned Left"] = p[key];
      } else if (key === "bushTurnRight") {
        _o["Bush Turned Right"] = p[key];
      } else if (key === "actions") {
        _o["Actions"] = p[key];
      }
    }

    _data.push(_o);
  });

  const staticHeaders = [
    "Customer", "Job Site", "Model", "Inspection Date", "Risk Rating",
    "Inspection Comments", "Unit #", "Recommended Actions", "Your Inspection ID", "Inspection Type",
    "Meter Read / SMU", "Pdf url", "Bush Turned Left", "Bush Turned Right", "Actions"
  ];

  const dynamicHeaders = Array.from(dynamicHeadersSet);
  const finalHeaders = [...staticHeaders.slice(0, 11), ...dynamicHeaders, ...staticHeaders.slice(11)];

  const replacer = (key: string, value: any) => value === null || value === undefined ? '' : value;
  const csvRows = _data.map(row =>
    finalHeaders.map(header => JSON.stringify(row[header] ?? '', replacer)).join(',')
  );
  csvRows.unshift(finalHeaders.join(','));

  const blob = new Blob([csvRows.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');

  a.href = url;
  a.download = `${customerName}.csv`;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

  getArrayFromStirng(stringToConvert: string, charToSplit: any) {
    if (stringToConvert == null)
      return "";
    else
      return stringToConvert.split(charToSplit);
  }
}
  


